import * as React from 'react';
import { colors } from '../../../designSystem/colors/color';
import { DesignSystemOverviewLayout, DesignSystemSection, DesignSystemSectionRow } from '../DesignSystemHelpers';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { colorGenerator } from '../../../designSystem/colors/colorGenerator';
import { TextField } from '../../../designSystem/formField/text/TextField';

export function ColorOverview(): JSX.Element
{
    const [hash1Text, setHash1Text] = React.useState<string>('');
    const [hash2Text, setHash2Text] = React.useState<string>('');

    return (
        <DesignSystemOverviewLayout>

            <DesignSystemSection title="ColorHash testers">
                <DesignSystemSectionRow title="ColorHash 1">
                    <Flex alignItems="flex-end" gap={8}>
                        <TextField label="Hash 1" value={hash1Text} onChange={setHash1Text} />
                        <div style={{backgroundColor:colorGenerator.getBrightColorFromString(hash1Text), width:'200px', height:'46px', marginLeft:'8px'}}>
                            <span>bright</span>
                        </div>
                        <div style={{backgroundColor:colorGenerator.getDarkColorFromString(hash1Text), width:'200px', height:'46px', marginLeft:'8px'}}>
                            <span style={{color:'white'}}>{'dark'}</span>
                        </div>
                    </Flex>
                </DesignSystemSectionRow>
                <DesignSystemSectionRow title="ColorHash 2">
                    <Flex alignItems="flex-end" gap={8}>
                        <TextField label="Hash 2" value={hash2Text} onChange={setHash2Text} />
                        <div style={{backgroundColor:colorGenerator.getBrightColorFromString(hash2Text), width:'200px', height:'46px', marginLeft:'8px'}}>
                            <span>bright</span>
                        </div>
                        <div style={{backgroundColor:colorGenerator.getDarkColorFromString(hash2Text), width:'200px', height:'46px', marginLeft:'8px'}}>
                            <span style={{color:'white'}}>{'dark'}</span>
                        </div>
                    </Flex>
                </DesignSystemSectionRow>
            </DesignSystemSection>
                        

            <DesignSystemSection title="Indexed colors">
                <DesignSystemSectionRow title="Indexable colors (light / dark variants)">
                    <Flex flexDirection="column">
                        {colors.newIndexed.map((color, index) => {
                            return (
                                    <Flex key={index} flexDirection="row" gap={8} style={{width:'100%'}}>
                                        <div style={{flexGrow:'1'}}>{index}</div>
                                        <div style={{backgroundColor:color.light, width:'200px'}}>{color.light}</div>
                                        <div style={{backgroundColor:color.dark, width:'200px'}}>{color.dark}</div>
                                    </Flex>
                            );
                        })}
                        </Flex>
                </DesignSystemSectionRow>
            </DesignSystemSection>

            <DesignSystemSection title="Fixed colors">
                <DesignSystemSectionRow title="All defined colors">
                    <NestedColorObject2 object={colors} prefix="" />
                </DesignSystemSectionRow>
            </DesignSystemSection>

        </DesignSystemOverviewLayout>
    );
}

const levelMultiplier = 20;

type NestedColorObject2Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object:any,
    prefix:string,
}
function NestedColorObject2(props:NestedColorObject2Props):JSX.Element
{
    return (
        <>
            {Object.keys(props.object).map(key =>
            {
                const name = (props.prefix ? (props.prefix + '.') : '') + key;
                return (
                    <React.Fragment key={name}>
                        {key && typeof props.object[key] === 'string' &&
                            <div key={key} style={{display:'flex', width:'100%', gap:'8px', paddingLeft:`${levelMultiplier}px`}}>
                                <div style={{flexGrow:'1'}}>{name}</div>
                                <div style={{backgroundColor:props.object[key], width:'200px'}}>{props.object[key]}</div>
                            </div>
                        }
                        {key && typeof props.object[key] === 'object' &&
                            <NestedColorObject2 key={key} object={props.object[key]} prefix={name} />
                        }
                    </React.Fragment>
                );
            })}
        </>
    );
}